/*=============================================
=            Table Header Styles            =
=============================================*/

:host {
  @apply flex;

  &.pk-table--header {
    @apply w-full bg-transparent;

    &.mobile {
      @apply hidden sm:flex;
    }

    &.is-hidden {
      @apply hidden;
    }

    &.fixed-width {
      @apply fixed;
    }

    &::slotted(pk-table-row) {
      @apply rounded-none border-none bg-transparent shadow-none;
    }
  }
}
